// The size in kilobytes, as the tables show file sizes.
export const formatFileSize = (bytes: number | null | undefined): string =>
  bytes ? `${(bytes / 1000).toFixed()} KB` : '-';
